import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { boardService } from '../services/firebaseService';
import { BoardMember } from '../types';

// Convert Google Drive URL to direct image URL
const convertGoogleDriveUrl = (url: string): string => {
  if (!url) return url;
  
  // If it's already in the correct format, return as-is
  if (url.includes('drive.google.com/uc?export=view&id=')) {
    return url;
  }
  
  // Extract file ID from various Google Drive URL formats:
  let fileId: string | null = null;
  
  // Format 1: https://drive.google.com/file/d/FILE_ID/view
  const fileDMatch = url.match(/\/file\/d\/([a-zA-Z0-9_-]+)/);
  if (fileDMatch) {
    fileId = fileDMatch[1];
  }
  
  // Format 2: https://drive.google.com/uc?export=view&id=FILE_ID
  // Format 3: https://drive.google.com/open?id=FILE_ID
  if (!fileId) {
    const idMatch = url.match(/[?&]id=([a-zA-Z0-9_-]+)/);
    if (idMatch) {
      fileId = idMatch[1];
    }
  }
  
  // Convert to direct view URL
  if (fileId) {
    return `https://drive.google.com/uc?export=view&id=${fileId}`;
  }
  
  return url;
};

const BoardPage: React.FC = () => {
  const [members, setMembers] = useState<BoardMember[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    boardService.getBoardMembers().then((list) => {
      console.log('✅ Board members loaded:', list.length, list);
      setMembers(list);
      setLoading(false);
    }).catch((error) => {
      console.error('❌ Error loading board members:', error);
      console.error('Error details:', error.code, error.message);
      setLoading(false);
    });
  }, []);
  return (
    <Layout>
      <div className="container">
        <h1>Board Members</h1>
        {loading ? (
          <div className="loading"><div className="spinner" /></div>
        ) : (
          <div className="grid" style={{ gridTemplateColumns: '1fr' }}>
            {members.map((m) => {
              // Convert Google Drive URL if needed
              const imageUrl = m.photoUrl ? convertGoogleDriveUrl(m.photoUrl) : null;
              
              return (
                <div key={m.id} className="card">
                  {imageUrl && (
                    <img
                      src={imageUrl}
                      alt={m.name}
                      onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.style.display = 'none';
                        console.error('Failed to load image for', m.name, 'URL:', imageUrl);
                      }}
                      style={{ width: '20%', borderRadius: '8px', marginBottom: '1rem', display: 'block', filter: 'grayscale(100%)' }}
                    />
                  )}
                  <h3>{m.name}</h3>
                  <p style={{ color: 'var(--text-dark)' }}>{m.role}</p>
                  {m.bio && (
                    <div style={{ whiteSpace: 'pre-wrap' }}>
                      {m.bio.split('\n').filter(para => para.trim()).map((paragraph, index) => (
                        <p key={index} style={{ marginBottom: '0.25rem' }}>
                          {paragraph}
                        </p>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </Layout>
  );
};

export default BoardPage;
